import type { PortalMediaOutput } from '@garage/shared';
import { useState } from 'react';
import { formatDateTime } from '../../garage/lib/format.js';
import { useTz } from '../timezone.js';
import { PortalPhoto } from './PortalPhoto.js';
import { PortalPhotoViewer } from './PortalPhotoViewer.js';

/** Photos publiées, de la plus récente à la plus ancienne ; appui = visionneuse intégrée. */
export function PortalPhotos({ media }: { media: PortalMediaOutput[] }) {
  const tz = useTz();
  const sorted = [...media].sort((a, b) => b.takenAt.localeCompare(a.takenAt));
  const [open, setOpen] = useState<number | null>(null);

  return (
    <>
      <ul className="grid grid-cols-3 gap-2 sm:grid-cols-4">
        {sorted.map((m, i) => (
          <li key={m.id}>
            <button
              type="button"
              className="block w-full overflow-hidden rounded-lg transition-opacity hover:opacity-90"
              onClick={() => setOpen(i)}
              aria-label={m.caption ?? `Photo du ${formatDateTime(m.takenAt, tz)}`}
            >
              <PortalPhoto id={m.id} variant="thumb" alt="" />
            </button>
          </li>
        ))}
      </ul>
      <PortalPhotoViewer
        photos={sorted.map((m) => ({ id: m.id, alt: m.caption ?? '', caption: m.caption }))}
        open={open}
        onIndexChange={setOpen}
        onClose={() => setOpen(null)}
        meta={(p) => {
          const m = sorted.find((x) => x.id === p.id);
          return m ? formatDateTime(m.takenAt, tz) : null;
        }}
      />
    </>
  );
}
